import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { SonicUser } from "../../../common/classes/SonicUser";
import NoResults from "../../../common/NoResults";

import styles from "../../management/db-list/DBList.module.scss";

type ListProps = {
  managers: Array<SonicUser>;
};

export const ManagerList: React.FC<ListProps> = ({ managers }) => {
  return (
    <>
      {managers.length === 0 ? (
        <NoResults />
      ) : (
        <div className={styles["f-dbList"]}>
          <div
            className={`${styles["f-dbList__category"]} ${styles["head"]} ${styles["manager"]}`}
          >
            <div>管理者名</div>
            <div>メールアドレス</div>
            <div>担当校</div>
            <div>認証</div>
          </div>
          {managers.map((manager, i) => (
            <div
              className={`${styles["f-dbList__category"]} ${styles["body"]} ${styles["manager"]}`}
              key={i}
            >
              <div>{manager.meta.name}</div>
              <div>{manager.meta.email}</div>
              <div>{manager.meta.school?.name}</div>
              <FontAwesomeIcon
                icon={["fas", "user-check"]}
                className={
                  manager.meta.active === 1
                    ? styles["active"]
                    : styles["inactive"]
                }
              />
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default ManagerList;
